<div class="lp-request-password-reset-form">
  <h1
    i18n="@@auth.requestPasswordReset.titel"
    class="dm-margin-bottom-12 dm-text-display-xs desktop:dm-text-display-sm dm-text-weight-semibold"
  >
    Passwort vergessen?
  </h1>

  @if (isForAdmin()) {
    <p i18n="@@auth.requestPasswordReset.anleitungDu" class="dm-text-md dm-margin-bottom-32">
      Keine Sorge, wir senden dir Anweisungen zum Zurücksetzen.
    </p>
  } @else {
    <p i18n="@@auth.requestPasswordReset.anleitungSie" class="dm-text-md dm-margin-bottom-32">
      Keine Sorge, wir senden Ihnen Anweisungen zum Zurücksetzen.
    </p>
  }

  <form class="lp-request-password-reset-form__form" [formRoot]="resetForm">
    <lp-form-alert [message]="formErrorMessage()" />

    <dm-input
      inputtype="email"
      autocomplete="username"
      i18n-placeholder="@@auth.emailPlatzhalter"
      placeholder="E-Mail-Adresse eingeben"
      [formField]="resetForm.email"
      [errormsg]="emailErrorMessage()"
    />

    <div class="dm-margin-top-20">
      <dm-button
        [dmType]="'submit'"
        [isLoading]="loadingStatus() === 'loading'"
        [grow]="true"
        [disabled]="resetForm().invalid()"
        i18n="@@auth.requestPasswordReset.zuruecksetzen"
        >Passwort zurücksetzen
      </dm-button>
    </div>

    <p i18n="@@auth.zurueckZumLogin" class="dm-text-sm dm-text-align-center"><a [routerLink]="loginRoute">Zurück zum Login</a></p>
  </form>
</div>
